import { LinearProgress } from "@mui/material";

const LoadingProgress = () => <LinearProgress style={{ position: 'fixed', bottom: 0, width: '100%', zIndex: 10 }} />

export default LoadingProgress